import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import { TIMEFRAME, STATUS_FILTER } from '../../constants';

/**
 * Reusable Filter Bar component for todos
 * Combines status and timeframe filters
 */
const FilterBar = ({ 
  statusFilter, 
  timeframeFilter, 
  timeframeCounts,
  onStatusChange,
  onTimeframeChange,
  showStatusFilter = true,
  showTimeframeFilter = true,
  statusCounts,
}) => {
  return (
    <div className="flex gap-1" style={{ marginBottom: '1rem', flexWrap: 'wrap' }}>
      {showStatusFilter && onStatusChange && (
        <>
          <div className="flex gap-1">
            <Button
              variant={statusFilter === STATUS_FILTER.ALL ? 'primary' : 'secondary'}
              size="small"
              onClick={() => onStatusChange(STATUS_FILTER.ALL)}
            >
              All {statusCounts?.all != null && `(${statusCounts.all})`}
            </Button>
            <Button
              variant={statusFilter === STATUS_FILTER.ACTIVE ? 'primary' : 'secondary'}
              size="small"
              onClick={() => onStatusChange(STATUS_FILTER.ACTIVE)}
            >
              Active {statusCounts?.active != null && `(${statusCounts.active})`}
            </Button>
            <Button
              variant={statusFilter === STATUS_FILTER.COMPLETED ? 'primary' : 'secondary'}
              size="small"
              onClick={() => onStatusChange(STATUS_FILTER.COMPLETED)}
            >
              Completed {statusCounts?.completed != null && `(${statusCounts.completed})`}
            </Button>
          </div>
          {showTimeframeFilter && (
            <div style={{ width: '1px', background: 'var(--color-border)', margin: '0 0.5rem' }} />
          )}
        </>
      )}

      {showTimeframeFilter && onTimeframeChange && timeframeCounts && (
        <div className="flex gap-1">
          <Button
            variant={timeframeFilter === TIMEFRAME.ALL ? 'primary' : 'secondary'}
            size="small"
            onClick={() => onTimeframeChange(TIMEFRAME.ALL)}
          >
            All Times
          </Button>
          <Button
            variant={timeframeFilter === TIMEFRAME.OVERDUE ? 'primary' : 'secondary'}
            size="small"
            onClick={() => onTimeframeChange(TIMEFRAME.OVERDUE)}
          >
            Overdue ({timeframeCounts.overdue})
          </Button>
          <Button
            variant={timeframeFilter === TIMEFRAME.THIS_WEEK ? 'primary' : 'secondary'}
            size="small"
            onClick={() => onTimeframeChange(TIMEFRAME.THIS_WEEK)}
          >
            This Week ({timeframeCounts.thisWeek})
          </Button>
          <Button
            variant={timeframeFilter === TIMEFRAME.NEXT_WEEK ? 'primary' : 'secondary'}
            size="small"
            onClick={() => onTimeframeChange(TIMEFRAME.NEXT_WEEK)}
          >
            Next Week ({timeframeCounts.nextWeek})
          </Button>
          <Button
            variant={timeframeFilter === TIMEFRAME.NEXT_MONTH ? 'primary' : 'secondary'}
            size="small"
            onClick={() => onTimeframeChange(TIMEFRAME.NEXT_MONTH)}
          >
            Due in next 30 Days ({timeframeCounts.nextMonth})
          </Button>
          <Button
            variant={timeframeFilter === TIMEFRAME.LATER ? 'primary' : 'secondary'}
            size="small"
            onClick={() => onTimeframeChange(TIMEFRAME.LATER)}
          >
            Later ({timeframeCounts.later})
          </Button>
        </div>
      )}
    </div>
  );
};

FilterBar.propTypes = {
  statusFilter: PropTypes.string,
  timeframeFilter: PropTypes.string,
  timeframeCounts: PropTypes.shape({
    overdue: PropTypes.number,
    thisWeek: PropTypes.number,
    nextWeek: PropTypes.number,
    nextMonth: PropTypes.number,
    later: PropTypes.number,
  }),
  onStatusChange: PropTypes.func,
  onTimeframeChange: PropTypes.func,
  showStatusFilter: PropTypes.bool,
  showTimeframeFilter: PropTypes.bool,
  statusCounts: PropTypes.shape({
    all: PropTypes.number,
    active: PropTypes.number,
    completed: PropTypes.number,
  }),
};

export default FilterBar;
